/* CR8 scroll/micro-motion layer.

   Pure progressive enhancement:
   - Does absolutely nothing when the visitor prefers reduced motion.
   - Reveal classes are only ever ADDED by this script, so with JavaScript
     disabled no content is hidden and no layout shifts.
   - The first section (the story hero) and everything inside a purchase
     panel are deliberately never touched: above-the-fold content must not
     flash, and buying UI must never be delayed or hidden.

   The matching styles live in cr8-theme.css under the
   prefers-reduced-motion: no-preference media query. */

(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) return;

  var REVEAL_SELECTOR = [
    '.cr8-eyebrow',
    '.cr8-heading',
    '.cr8-body',
    '.cr8-card',
    '.cr8-tag',
    '.cr8-timeline__card',
    '.cr8-why-page__stat',
    '.cr8-founder-story__paragraph',
    '.cr8-founder-story__signature',
    '.cr8-faq__item',
    '.cr8-trust-strip__item'
  ].join(',');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cr8-in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  function prepare() {
    var sections = document.querySelectorAll('.cr8-section');
    sections.forEach(function (section, sectionIndex) {
      if (sectionIndex === 0) return; // never touch the opening hero

      var targets = section.querySelectorAll(REVEAL_SELECTOR);
      var staggerIndex = 0;

      targets.forEach(function (el) {
        if (el.closest('[data-cr8-purchase-panel]')) return; // never delay buying UI
        if (el.classList.contains('cr8-reveal')) return;

        // Elements already on screen when we run get revealed instantly with
        // no transition, so nothing that is visible ever blinks out.
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) return;

        el.classList.add('cr8-reveal');
        el.style.setProperty('--cr8-reveal-delay', Math.min(staggerIndex * 60, 360) + 'ms');
        staggerIndex += 1;
        observer.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepare);
  } else {
    prepare();
  }
})();
